import { render, staticRenderFns } from "./ower.vue?vue&type=template&id=499b6bb4&scoped=true&"
import script from "./ower.vue?vue&type=script&lang=js&"
export * from "./ower.vue?vue&type=script&lang=js&"
import style0 from "./ower.vue?vue&type=style&index=0&id=499b6bb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499b6bb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('499b6bb4')) {
      api.createRecord('499b6bb4', component.options)
    } else {
      api.reload('499b6bb4', component.options)
    }
    module.hot.accept("./ower.vue?vue&type=template&id=499b6bb4&scoped=true&", function () {
      api.rerender('499b6bb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inOutBound/statis/ower.vue"
export default component.exports